var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawTweetstormReN0Rs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 871.1778,
    height: 651.0819,
    viewBox: "0 0 871.1778 651.0819",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      userSelect: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "69.394 610.045 84.978 617.567 121.409 561.037 98.408 549.935 69.394 610.045",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.40844,750.49572l47.92189,23.13234.29257-.606a20.71308,20.71308,0,0,0-9.64788-27.65636l-.00116-.00056-5.54751-10.86653-19.53825-1.24252-4.18326-2.01932Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.394 631.117 202.698 631.116 210.93 564.37 185.39 564.371 185.394 631.117",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19561,773.62806l53.2129-.002v-.673a20.71307,20.71307,0,0,0-20.71194-20.71162h-.00128l-9.72-7.37412-18.13541,7.37524-4.64513.00016Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.95494,446.01866,386.78409,582.7606l-5.39646,17.99264,7.08127,12.743-10.399,95.91159,4.22117,9.29331-11.79395,7.27366h-23.999L345.22447,624.6604l-5.92818-14.87516v-8.198l-12.068-61.77918L324.4446,635.982l-3.85285,7.43165c-14.35147,32.56122-33.68411,43.22248-47.35147,67.56122l-24-13,.50325-9.6951c-4.82146-2.44108,7.23886-9.57559,8.39776-14.85409l2.099-9.45081,14-29,.53427-10.21269-3.8316-69.4615,1.803-93.53851,31.48053-24.07276Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.82948,254.78094a96.90144,96.90144,0,0,0,12.51,27.53c12.48,18.87,30.34,33.3,49.97,44.85,1.36.81,2.74,1.6,4.12,2.38h13.77l.48-1.1v-.01l.55994-1.27.07007-.15.03.15.55005,2.38h6.75989c.55994-.79,1.11-1.58,1.65-2.38.79-1.17,1.55-2.35,2.27-3.55a57.63468,57.63468,0,0,0,3.3999-6.52c.12011-.25.22009-.5.32007-.75l-.45-.49,1.86988-8.18-3.75989-.62,4.12-12.71c-.15-.47-.32007-.94-.5-1.41-2.31006-5.85-6.65-10.22-11.80005-13.89-5.3-3.79-11.47-6.83-17.1399-9.99-2.66015-1.49-5.28-3.06-7.83007-4.72v-.01q-4.89-3.16508-9.49-6.77a1.42568,1.42568,0,0,1-.15-.11,1.06906,1.06906,0,0,1-.12-.1,140.9021,140.9021,0,0,1-34.31006-38.93.0098.0098,0,0,1-.01-.01c-.29993-.48-.57984-.96-.85987-1.45v-.01a136.25616,136.25616,0,0,1-9.41-19.65v-.01c-.20007-.5-.38-1-.57-1.5q-.39.66-.75,1.32a.0098.0098,0,0,0-.01.01C429.41944,214.46093,428.4994,235.361,433.82948,254.78094Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#f0f0f0",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11951,197.111a121.36517,121.36517,0,0,0,2.86988,27.54,118.54027,118.54027,0,0,0,3.3601,12.24006,121.346,121.346,0,0,0,10.12989,22.6c.23.39.45007.77.69006,1.15v.00994a102.34558,102.34558,0,0,0,5.75,8.66,47.722,47.722,0,0,0,11.4,11.46,30.08864,30.08864,0,0,0,11.98,4.63c.8.15,1.62.26,2.45.36005,3.31006.38995,6.73.54,10.01,1.24a21.84913,21.84913,0,0,1,4.82007,1.55c5.28,2.45,8.25,7.58,9.55,13.06.23.96.40992,1.93.54993,2.9,1.09,7.45-.11,15.19.51,22.65.06995.79.16,1.59.2699,2.38h.74011l.48-1.1v-.01c-.04993-.42-.09-.84-.13-1.27a96.29225,96.29225,0,0,1-.09009-11.01c.04-1.65.07007-3.31.05005-4.97-.02-1.33-.06995-2.66-.16993-3.98v-.01c-.07006-.82-.15-1.63-.26-2.44a31.58653,31.58653,0,0,0-1.82007-7.25,18.15177,18.15177,0,0,0-10.32-10.68,26.99231,26.99231,0,0,0-4.47009-1.25c-3.34986-.64-6.80994-.8-10.17993-1.22-.36-.04-.72-.09-1.07007-.15-.45-.07-.88989-.15-1.32984-.23a28.66611,28.66611,0,0,1-12.16015-5.27,51.90346,51.90346,0,0,1-10.98-11.92c-1.6399-2.35-3.2-4.75-4.64991-7.22a.0098.0098,0,0,0-.01-.01c-.07006-.12-.14-.23-.21-.35l-.01-.02a119.57137,119.57137,0,0,1-13.46008-34.17c-.09-.44-.19006-.88-.28992-1.32a120.88772,120.88772,0,0,1-2.67-26.4v-.01c0-.42.00989-.83.0199-1.25.02-.86-1.30994-1.05-1.32984-.19-.01.42-.02.84-.01,1.26A.0098.0098,0,0,0,439.11951,197.111Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.74031,260.36988a18.01813,18.01813,0,0,1-22.69431-5.41582c-.50869-.69934.55416-1.52268,1.06353-.82241a16.68437,16.68437,0,0,0,21.12073,4.99469c.76923-.39532,1.27488.85047.51005,1.24354Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.76106,284.36933a34.72843,34.72843,0,0,0-1.2295-25.2792c-.35485-.78953.88911-1.29863,1.24353-.51A36.12283,36.12283,0,0,1,486.001,284.888c-.27856.82057-1.517.29746-1.24-.51866Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.73305,223.81364a10.19914,10.19914,0,0,0,7.02237-6.65925c.268-.82369,1.50624-.29968,1.24.51866a11.42892,11.42892,0,0,1-7.75229,7.38412.69461.69461,0,0,1-.87679-.36674.67544.67544,0,0,1,.36675-.87679Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.79945,264.321v.01a131.2464,131.2464,0,0,0,2.66992,21.24v.01c.08008.48.19006.95.29,1.42a184.49574,184.49574,0,0,0,10.1101,31.61q1.78493,4.32,3.74,8.55c.35987.8.73,1.59,1.10987,2.38h1.4801l.48-1.1v-.01l.55994-1.27.07007-.15.03.15.55005,2.38h14.29993l2.77991-2.38,4.05-3.47-5.65992-6.18-.93005-1.02-.14-.15-.45-.49,1.86988-8.18-3.75989-.62,4.12-12.71,1.94995-6.01.49-1.51,2.85009-8.79,8.59986,1.61005,1.40014-4.9a135.98973,135.98973,0,0,1-6.42-18.41c-.01-.05-.03-.09-.04-.14a141.58293,141.58293,0,0,1-4.0199-51.96v-.01c.05994-.56.12989-1.13.21-1.68v-.02a133.63133,133.63133,0,0,1,4.32-21.34c.14-.53.29993-1.05.45007-1.57-.46008.2-.91.39-1.37011.59l-.01.01h-.02c-.73.32-1.46.66-2.16992,1.02-17.06006,8.29-29.61,23.85-36.74,41.79-.02.05-.04.09-.06006.14a96.39382,96.39382,0,0,0-6.57,29.43A114.86769,114.86769,0,0,0,494.79945,264.321Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#f0f0f0",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7494,329.541h1.58008c.5-.81,1.04-1.6,1.58-2.38q1.29-1.81494,2.66-3.55c.79-1,1.57995-1.99,2.37-2.98.81995-1.03,1.63-2.06,2.42-3.12l-.93005-1.02c-.15.2-.29993.4-.46008.6-2.55994,3.37-5.32984,6.61-7.7,10.07C521.73939,327.941,521.22938,328.731,520.7494,329.541Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.19138,180.16976c-.26.33-.53.67-.78,1.01q-2.925,3.795-5.53,7.83a117.99043,117.99043,0,0,0-8.22,14.85c-.19.4-.38.81-.56,1.22a119.26359,119.26359,0,0,0-9.84,35.44c-.02.12-.03.23-.04.35q-.49493,4.29-.64,8.61a51.78271,51.78271,0,0,0,1.59,16.12c.2.69.42,1.37.66,2.03a27.34619,27.34619,0,0,0,2.25,4.65,27.92323,27.92323,0,0,0,2.14,3.09c.47.6.96,1.19,1.48,1.76.3.33.61.66.92.99.26.25.51.51.77.76,2.69995,2.62,5.68,5.05,8.12,7.94l-.49,1.51c-2.35-2.98-5.37994-5.45-8.11-8.05a37.89691,37.89691,0,0,1-4.66-5.28c-.18-.26-.37-.52-.54-.79a26.749,26.749,0,0,1-2.38995-4.29c-.34-.75-.65-1.52-.93-2.32a47.89241,47.89241,0,0,1-2.2-16,103.41481,103.41481,0,0,1,.62-10.39c.04-.45.09-.89.15-1.34a121.63884,121.63884,0,0,1,5.52-24.14,122.66075,122.66075,0,0,1,13.76-28.18q2.475-3.765,5.25-7.35c.24-.33.49-.65.75-.98C541.77133,178.53975,542.72134,179.48977,542.19138,180.16976Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43738,241.33613A18.01811,18.01811,0,0,1,501.578,223.34837a.67262.67262,0,0,1,1.34431-.01634,16.68438,16.68438,0,0,0,13.85657,16.70413c.8522.14748.50588,1.44661-.34145,1.3Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.36105,277.36878a34.72847,34.72847,0,0,0,14.23814-20.92428c.192-.844,1.49177-.50156,1.3.34145a36.12285,36.12285,0,0,1-14.86034,21.74349c-.71645.48747-1.39034-.67584-.67778-1.16066Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.26275,203.71468a10.1991,10.1991,0,0,0,9.61629-1.08908c.70992-.49631,1.38308.66758.67778,1.16066a11.42893,11.42893,0,0,1-10.63552,1.2284.69462.69462,0,0,1-.47927-.82071.67544.67544,0,0,1,.82072-.47927Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.73626,
    cy: 176.87431,
    r: 37.15829,
    fill: "#6c63ff",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.28589,316.659a29.29548,29.29548,0,0,1-7.87071-1.0798,1.06275,1.06275,0,0,1-.78408-1.14216,1.08346,1.08346,0,0,1,.994-1.00448c3.84044-.38648,5.33327-1.68731,5.88151-2.42755a.27343.27343,0,0,0,.03766-.26239.25021.25021,0,0,0-.18707-.1599,9.29266,9.29266,0,0,1-3.38265-1.40085,2.00835,2.00835,0,0,1-.00123-3.30176c.05155-.03519.06266-.06483.05742-.10372a.12289.12289,0,0,0-.08026-.10126,6.19167,6.19167,0,0,1-3.77469-3.316,2.00474,2.00474,0,0,1,.27937-2.1167,2.0484,2.0484,0,0,1,2.06731-.70629,16.24293,16.24293,0,0,1-3.07581-5.71542,2.0188,2.0188,0,0,1,3.36629-1.92809,17.58052,17.58052,0,0,0,8.021,4.49794,3.49855,3.49855,0,0,0,4.1908-2.56985,7.6211,7.6211,0,0,1,7.3518-5.813c4.02936,0,5.54071,1.85308,5.99788,2.63252l2.844-1.7083a.472.472,0,0,1,.70783.49422,8.17324,8.17324,0,0,1-1.202,3.17181l1.52648-.30468a.54962.54962,0,0,1,.51459.9091H539.765c-.48.52632-1.18044,1.282-1.79042,1.895a4.6951,4.6951,0,0,0-1.31749,2.69025C534.37276,314.20734,522.91351,316.659,516.28589,316.659Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.08117,283.35H602.21935a3.5,3.5,0,0,1,0-7h429.86182a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.08117,304.83341H602.21935a3.5,3.5,0,0,1,0-7h429.86182a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.96544,326.31632H602.21935a3.5,3.5,0,0,1,0-7H889.96544a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.73626,
    cy: 308.35649,
    r: 37.15829,
    fill: "#e6e6e6",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.08117,414.83219H602.21935a3.5,3.5,0,0,1,0-7h429.86182a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.08117,436.31559H602.21935a3.5,3.5,0,0,1,0-7h429.86182a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.96544,457.7985H602.21935a3.5,3.5,0,0,1,0-7H889.96544a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.73626,
    cy: 439.83867,
    r: 37.15829,
    fill: "#6c63ff",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.28589,579.62333a29.29548,29.29548,0,0,1-7.87071-1.0798,1.06276,1.06276,0,0,1-.78408-1.14216,1.08347,1.08347,0,0,1,.994-1.00449c3.84044-.38648,5.33327-1.6873,5.88151-2.42755a.27341.27341,0,0,0,.03766-.26238.25024.25024,0,0,0-.18707-.15991,9.29264,9.29264,0,0,1-3.38265-1.40084,2.00836,2.00836,0,0,1-.00123-3.30177c.05155-.03519.06266-.06482.05742-.10372a.12288.12288,0,0,0-.08026-.10125,6.19167,6.19167,0,0,1-3.77469-3.316,2.00474,2.00474,0,0,1,.27937-2.1167,2.0484,2.0484,0,0,1,2.06731-.70629,16.24306,16.24306,0,0,1-3.07581-5.71543,2.0188,2.0188,0,0,1,3.36629-1.92809,17.58053,17.58053,0,0,0,8.021,4.498,3.49855,3.49855,0,0,0,4.1908-2.56986,7.62111,7.62111,0,0,1,7.3518-5.813c4.02936,0,5.54071,1.85308,5.99788,2.63252l2.844-1.7083a.472.472,0,0,1,.70783.49422,8.1732,8.1732,0,0,1-1.202,3.1718l1.52648-.30467a.54962.54962,0,0,1,.51459.90909H539.765c-.48.52632-1.18044,1.282-1.79042,1.89506a4.69507,4.69507,0,0,0-1.31749,2.69025C534.37276,577.1717,522.91351,579.62333,516.28589,579.62333Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.08117,546.31437H602.21935a3.5,3.5,0,1,1,0-7h429.86182a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.08117,567.79777H602.21935a3.5,3.5,0,0,1,0-7h429.86182a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.96544,589.28068H602.21935a3.5,3.5,0,0,1,0-7H889.96544a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e7e8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.59371,473.02989a12.13894,12.13894,0,0,0,.01729-18.6136l-4.24915-98.50223-14.57807-27.48241-15.636-3.04666,3.59556,45.15947,13.11465,85.963a12.20473,12.20473,0,0,0,17.73569,16.52244Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.38647,
    cy: 96.52099,
    r: 31.18014,
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.087,471.25413c-41.10547.001-71.94043-15.481-72.3623-15.69727l-.36524-.1875.11231-.39453c1.10351-3.86474,2.14892-10.34814.25732-11.29346a1.29567,1.29567,0,0,1-.80615-.95166c-.1084-.77685.66943-1.48681,1.74609-2.47021,2.08985-1.90869,4.95215-4.52246,3.27344-8.71826-2.95947-7.398,5.36182-45.30811,5.8999-47.73828l-3.5542-60.42871a50.26813,50.26813,0,0,1,37.1709-51.37207l.0791-.021.08155.00537c1.15576.06494,2.37939-3.85986,3.30762-6.73193,1.37109-4.24512,2.27636-6.85352,3.8208-6.74268,11.95654.771,19.92382,1.27539,25.23291,1.605,10.0664.62549,11.83007,12.86914,12.04687,14.82373a60.22933,60.22933,0,0,1,27.30127,65.17041l-5.01709,21.57373-4.43359,10.36573,1.46093,20.45019c6.877,5.71826,4.90625,17.4165,4.51465,19.39307,6.55274,6.77881,2.52881,14.75683,1.55274,16.44629a15.9757,15.9757,0,0,1,2.88134,14.8955l6.03516,19.61377-.45508.15869A150.646,150.646,0,0,1,341.087,471.25413Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.01812,363.54563l-19.58692-37.6665,13.54346-36.11524.28613-.04638a26.512,26.512,0,0,1,27.03076,12.4458,72.59321,72.59321,0,0,1,9.17383,23.585c4.38477,23.38623,5.9082,28.10547,5.92334,28.15039l.16943.51172Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.73671,
    cy: 312.63031,
    r: 37.15829,
    fill: "#6c63ff",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28635,452.415a29.2955,29.2955,0,0,1-7.87072-1.0798,1.06273,1.06273,0,0,1-.78407-1.14216,1.08345,1.08345,0,0,1,.994-1.00448c3.84044-.38648,5.33327-1.68731,5.88151-2.42755a.27343.27343,0,0,0,.03766-.26239.25021.25021,0,0,0-.18707-.1599,9.29253,9.29253,0,0,1-3.38264-1.40085,2.00834,2.00834,0,0,1-.00124-3.30176c.05155-.03519.06267-.06483.05742-.10372a.12287.12287,0,0,0-.08026-.10125,6.19167,6.19167,0,0,1-3.77468-3.316,2.00472,2.00472,0,0,1,.27936-2.1167,2.0484,2.0484,0,0,1,2.06731-.70629,16.24291,16.24291,0,0,1-3.0758-5.71542,2.0188,2.0188,0,0,1,3.36628-1.92809,17.58058,17.58058,0,0,0,8.021,4.49794,3.49855,3.49855,0,0,0,4.1908-2.56985,7.6211,7.6211,0,0,1,7.35181-5.813c4.02935,0,5.5407,1.85308,5.99788,2.63253l2.844-1.7083a.472.472,0,0,1,.70783.49421,8.17324,8.17324,0,0,1-1.202,3.17181l1.52648-.30468a.54962.54962,0,0,1,.51459.9091h-.00031c-.48.52632-1.18044,1.282-1.79041,1.89505a4.69514,4.69514,0,0,0-1.3175,2.69025C398.37321,449.96334,386.914,452.415,380.28635,452.415Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#fff",
    style: {
      isolation: "isolate",
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.63527,475.70034a12.13892,12.13892,0,0,1-6.9551-17.26537l-32.77828-92.98564,3.28189-30.93594,13.373-8.656,13.49885,43.24449L359.933,453.75717a12.20472,12.20472,0,0,1-10.2977,21.94317Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.829 177.516 158.829 165.516 176.829 225.516 135.282 238.681 127.829 177.516",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35894,240.57884a3.51085,3.51085,0,0,1-1.13233-.18262,7.42105,7.42105,0,0,1-3.42187-3.04151c-5.52637-7.94824-8.19483-18.54541-7.93018-31.49755.11182-5.4795.73193-12.48536,4.56934-18.06983,3.22705-4.6958,9.75488-8.42236,15.83838-6.55176-.332-2.44287,1.31982-4.86963,3.28076-6.0708,2.3042-1.41113,5.07812-1.6709,7.5249-1.90088,6.17871-.5791,12.56592-1.17773,18.82227.00782,7.01513,1.33056,12.751,4.94629,15.73681,9.91992l.061.15625.60693,2.94726a2.79881,2.79881,0,0,0,3.72656,2.05567,2.53941,2.53941,0,0,1,3.40772,2.74121l-.16944,1.17236,1.76465-.33008a2.54057,2.54057,0,0,1,2.84912,3.37745l-.49853,1.34814a2.6725,2.6725,0,0,1,1.94287.85547,2.45647,2.45647,0,0,1,.333,2.894,23.014,23.014,0,0,1-8.1294,8.1792,19.21349,19.21349,0,0,1-5.94092,2.33643,114.10192,114.10192,0,0,1-41.394,1.24463,23.33715,23.33715,0,0,1,.92529,8.3789c-.44042,3.53369-2.51513,6.44971-5.28564,7.42871a12.76416,12.76416,0,0,1-1.93164.46582,11.32535,11.32535,0,0,0-1.84424.44825,5.397,5.397,0,0,0-1.58008,9.22412l1.36621-1.42383-.44433,1.81006a2.597,2.597,0,0,1-1.32422,1.64892A3.63924,3.63924,0,0,1,310.35894,240.57884Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.08115,774.351a1.18647,1.18647,0,0,1-1.19007,1.19h-280.29a1.19,1.19,0,0,1,0-2.38h280.29A1.18651,1.18651,0,0,1,447.08115,774.351Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.59569,161.01154H485.27232a1.0156,1.0156,0,0,1,0-2.0307h549.32337a1.0156,1.0156,0,0,1,0,2.0307Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#cacaca",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.21632,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.9584,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.70047,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.98251,131.29066H985.16577a2.03119,2.03119,0,0,1,0-4.06139h26.81674a2.03119,2.03119,0,0,1,0,4.06139Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.98251,138.90576H985.16577a2.03119,2.03119,0,0,1,0-4.06139h26.81674a2.03119,2.03119,0,0,1,0,4.06139Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.98251,146.52086H985.16577a2.03119,2.03119,0,0,1,0-4.06139h26.81674a2.03119,2.03119,0,0,1,0,4.06139Z",
    transform: "translate(-164.4111 -124.45905)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTweetstormReN0Rs);
export default __webpack_public_path__ + "static/media/undraw_tweetstorm_re_n0rs.b6aab5ae3fc416721d9c2539bfbbd46d.svg";
export { ForwardRef as ReactComponent };